import { BASE_URL } from "./variables";

export const getSpendingPlans = async (patientId) => {
  try {
    const response = await fetch(`${BASE_URL}/spending-plan?PatientId=${patientId}`,
      {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjU5NSwiYnVzaW5lc3NJZCI6NzEsIk1lbWJlcklEIjo5MTksInVzZXJuYW1lIjoiYW5rb3RhLmFkbWluIiwiZmlyc3ROYW1lIjoiSm9obiIsImxhc3ROYW1lIjoiRG9lIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.oCgeNmQXN2gsf64gLZ4x70AsUUkY6k9tFZDTf5bGll4'
      }
    }
    );
    
    // Handle 404 as "no plans found" rather than an error
    if (response.status === 404) {
      console.log('No spending plans found for patient:', patientId);
      return { data: [] };
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching spending plans:", error);
    return { data: [] };
  }
};

export const getSpendingPlanLines = async (planId) => {
  try {
    const response = await fetch(`${BASE_URL}/spending-plan-lines?plan_id=${planId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE1MzAxMCwiYnVzaW5lc3NJZCI6MTA0NzAsIk1lbWJlcklEIjoxNDU3MTcsInVzZXJuYW1lIjoic2VjdXJlLmFkbWluIiwiZmlyc3ROYW1lIjoiU3VwcG9ydCIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.fJaUKmFT1cv_AP-FGX-I8tBArpzMD5DF9l3-zqHY6aU'
      }
    });
    
    // Handle 404 as "no plan lines found" rather than an error
    if (response.status === 404) {
      console.log('No spending plan lines found for plan:', planId);
      return { data: [] };
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching spending plan lines:", error);
    return { data: [] };
  }
};
